import React, { Component } from 'react';
import { connect } from 'react-redux';
import './search.scss';
import { encodeSpecialCharacters } from '../../utils';

class SearchForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isCollapsed: true,
      inputValue: '',
    };

    this.setCollapsed = this.setCollapsed.bind(this);
    this.unsetCollapsed = this.unsetCollapsed.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClear = this.handleClear.bind(this);
    this.createCSSClassName = this.createCSSClassName.bind(this);
  }


  componentDidUpdate(prevState) {
    if (prevState.isCollapsed !== this.state.isCollapsed || !this.state.isCollapsed) {
      if (this.state.isCollapsed) {
        document.body.classList.remove("search-expanded");
      } else {
        document.body.classList.add("search-expanded");
      }
    }
  }

  setCollapsed() {
    if (this.props.canCollapse) {
      this.setState({
        isCollapsed: true,
        inputValue: '',
      });
    }
  }

  unsetCollapsed() {
    if (this.props.canCollapse) {
      this.setState({
        isCollapsed: false,
        inputValue: this.state.inputValue,
      });

      this.searchField.focus();
    }
  }

  handleInputChange(event) {
    this.setState({
      inputValue: event.target.value,
    });
  }

  handleSubmit(event, parentIsNav) {
    const { dispatch } = this.props;
    const input = encodeURIComponent(this.state.inputValue);

    if (input) {
      window.location.href = `https://www.purewow.com/search/${input}/1`;
    }

    if (parentIsNav) {
      dispatch({
        type: 'SIDEBAR_TOGGLE',
      });
    }

    event.preventDefault();
  }

  handleClear() {
    this.setState({
      inputValue: '',
    });
  }
 
  // gives some context to what the siblings of the rendered markup are (ex. this is a "social" when rendered in HeaderFixed since its siblings have class "social")
  createCSSClassName() {
    const { isCollapsed } = this.state;
    const { cssClass, canCollapse } = this.props;

    let className = 'nav-search';

    if (cssClass) {
      className = `${cssClass} ${className}`;
    }

    if (canCollapse) {
      className += `${isCollapsed ? ' unexpanded' : ' expanded'}`;
    }

    return className;
  }

  render() {
    const { inputValue } = this.state;
    const { canCollapse, parent } = this.props;
    const parentIsNav = parent === "nav";
    const parentIsFooter = parent === "footer";
    const className = this.createCSSClassName();
    const { isCollapsed } = this.state;

    return (
      <div className={className} onBlur={this.setCollapsed}>
        <div
          className={`icon-search nav-search-icon nav-search-icon-new ${isCollapsed ? "unexpanded" : "expanded"}`}
          onClick={() => (canCollapse ? this.unsetCollapsed() : this.handleSubmit()) }
        />

        <form className="nav-search-form" role="search" onSubmit={(e) => this.handleSubmit(e, parentIsNav)}>
          <input
            ref={el => this.searchField = el}
            id="search"
            type="text"
            aria-label="search"
            title="Type search term here"
            className="nav-search-form-input"
            placeholder="SEARCH..."
            value={inputValue}
            onChange={this.handleInputChange} />
        </form>

        {(!parentIsNav && !parentIsFooter) && 
          <div className="icon-close-icon-NEW nav-search-close" onClick={this.handleClear} onKeyUp={this.handleClear} />
        }
      </div>
    );
  }
}

const mapStateToProps = ({ pageData }) => ({
  q: pageData.q,
});

const mapDispatchToProps = dispatch => ({
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchForm);
